import React from 'react';
import { Shield, Target, Zap } from 'lucide-react';
import { BenefitCard } from '../../components/BenefitCard';
export function KidsTaekwondoBenefits() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-2175">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2176">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-2177">
          <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-2178">
            Why Families Choose Storm
          </h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-2179">
          <BenefitCard icon={Shield} title="Unshakeable Confidence" description="Watch your child stand taller, speak clearer, and believe in their ability to overcome challenges." data-id="element-2180" />
          <BenefitCard icon={Target} title="Laser Focus" description="Structured drills improve attention span and concentration, carrying over directly to better grades in school." data-id="element-2181" />
          <BenefitCard icon={Zap} title="Real Discipline" description="We teach the importance of doing the right thing, even when it's hard, building strong character." data-id="element-2182" />
        </div>
      </div>
    </section>;
}